import type { SkillCategory } from '../types'

interface SkillCardProps {
  category: SkillCategory
}

const levelColors = {
  beginner: 'bg-slate-200 dark:bg-slate-700',
  intermediate: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300',
  advanced: 'bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300',
  expert: 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300',
}

export function SkillCard({ category }: SkillCardProps) {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow duration-200">
      <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-4">
        {category.name}
      </h3>
      <div className="flex flex-wrap gap-2">
        {category.skills.map((skill) => (
          <span
            key={skill.name}
            className={`px-3 py-1 rounded-full text-sm font-medium ${
              skill.level
                ? levelColors[skill.level]
                : 'bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-300'
            }`}
          >
            {skill.name}
          </span>
        ))}
      </div>
    </div>
  )
}
